import { useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useFeatureToggle } from '@flopflip/react-redux';

import { FeatureFlag } from 'constants/featureFlags';
import { useEffectSafeStrictMode } from 'hooks/useEffectSafeStrictMode';

import {
  closePendingChangesAuthorsSelectionAction,
  loadPendingChangesAiRunsAction,
  openPendingChangesAuthorsSelectionAction,
} from 'store/loanApplications/actions/pendingChangesAuthorsSelection.actions';
import { selectPendingChangesAiExecutionIds } from 'store/loanApplications/selectors/pendingChangesAuthors.selectors';

/**
 * Owns the per-loan "whose pending changes are shown" selection while the loan page is open. A layout
 * effect opens it so the selection header is in place before any child's first loan request.
 */
export const usePendingChangesAuthorsSelection = applicationId => {
  const dispatch = useDispatch();

  const isPendingChangesByUserEnabled = useFeatureToggle(FeatureFlag.PendingChangesByUser);

  const aiExecutionIds = useSelector(selectPendingChangesAiExecutionIds);

  useLayoutEffect(() => {
    if (!isPendingChangesByUserEnabled || !applicationId) {
      return;
    }

    dispatch(openPendingChangesAuthorsSelectionAction({ applicationId }));

    return () => {
      dispatch(closePendingChangesAuthorsSelectionAction({ applicationId }));
    };
  }, [dispatch, isPendingChangesByUserEnabled, applicationId]);

  useEffectSafeStrictMode(() => {
    if (!isPendingChangesByUserEnabled || !aiExecutionIds.length) {
      return;
    }

    dispatch(loadPendingChangesAiRunsAction({ executionIds: aiExecutionIds }));
  }, [dispatch, isPendingChangesByUserEnabled, aiExecutionIds]);
};
